import AdBand from "@/components/yts/AdBand";
import { HOME_ROW_ADS } from "@/data/ads";

/**
 * The sponsor band that follows a row of cards on the landing page.
 *
 * The page opens with content and never with an ad, and the bands are placed
 * a chapter apart — the experiences, the food, the night, the culture, the
 * coast — so a visitor meets one while browsing instead of walking past three
 * stacked on the way to the next row. Bands rotate through the home slots, so a
 * partner's strip is never repeated in the same position twice running.
 */
export default function HomeRowAd({ index = 0 }) {
  const placement = HOME_ROW_ADS[index % HOME_ROW_ADS.length];
  // `slot` is the band's position on the page, so each of the page's banners
  // shows a different bookable experience instead of repeating every third one.
  // The band's spacing comes from AdBand alone, so every band on the page sits
  // the same distance from the row above it and the row below.
  return <AdBand placement={placement} slot={index} />;
}